import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=0454074c&scoped=true&"
import script from "./AddRole.vue?vue&type=script&lang=js&"
export * from "./AddRole.vue?vue&type=script&lang=js&"
import style0 from "./AddRole.vue?vue&type=style&index=0&id=0454074c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454074c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VForm,VTextField})
